import {JSX} from "react";

import {SummaryRow} from "@/entities/booking";

import {CurrencyUtils} from "@/shared/lib";

import type {CollapsibleRow} from "../../types";

import "./booking-summary-collapsible.scss";

interface BookingSummaryCollapsibleProps {
    title: string;
    amount?: string;
    rows: Array<CollapsibleRow>;
}

export function BookingSummaryCollapsible({title, amount, rows}: BookingSummaryCollapsibleProps): JSX.Element {
    const computed = rows.reduce((sum, r) => sum + CurrencyUtils.parseAmountToNumber(r.amount), 0);
    const amountToShow = amount ?? CurrencyUtils.formatUSD(computed, false);
    return (
        <details className="booking-summary-collapsible">
            <summary className="booking-summary-collapsible__summary">
                <SummaryRow label={title} amount={amountToShow} />
            </summary>
            <div className="booking-summary-collapsible__content">
                {rows.map((r, i) => (
                    <SummaryRow key={`${r.label}-${i}`} label={r.label} amount={r.amount} />
                ))}
            </div>
        </details>
    );
}
